import React from "react";
import PropTypes from "prop-types";
import config from "../config";
import TextItem from "./TextItem";
import UserItem from "./UserItem";

const Desktop = ({ className, ...rest }) => (
  <nav {...rest} className={className} role="navigation">
    {config.baseDesktopMenu.items.map((item) => (
      <TextItem {...item} key={item.title} />
    ))}

    <UserItem />
  </nav>
);

Desktop.propTypes = {
  className: PropTypes.string,
};

Desktop.defaultProps = {
  className: "",
};

export default Desktop;
